/**
 * 支持多个倒计时容器的通用倒计时逻辑：
 * 1.基础倒计时；
 * 2.mini倒计时；
 */
function startCountdown(endDate, containerSelector, endText = "------ THIS EVENT HAS ENDED ------") {
  // 获取容器元素
  const container = document.querySelector(containerSelector);
  if (!container) return;

  // 获取时间显示元素
  const daysEl = container.querySelector(".days");
  const hoursEl = container.querySelector(".hours");
  const minutesEl = container.querySelector(".minutes");
  const secondsEl = container.querySelector(".seconds");

  // 定义触发变化的日期：10月31日00:00:00（美国中部时间）---（测试---const triggerDate = new Date(Date.now() + 5000).getTime();）
  const triggerDate = new Date("2025-10-31T00:00:00-06:00").getTime();
  
  let hasTriggered = false; // 标志位：确保变化只执行一次
  let countdownInterval; // 定时器变量，用于结束后清除

  // 触发变化的操作（抽离为独立函数）
  function triggerChanges() {
    if (hasTriggered) return; // 防止重复执行

    // 中间虚线变实线
    const middleLine = document.querySelector('.timeline-line.timeline-line--dashed.timeline-line--middle');
    if (middleLine) {
      middleLine.classList.remove('timeline-line--dashed');
      middleLine.classList.add('timeline-line--solid');
    }

    // 第二个卡片图片替换为第一个卡片图片
    const firstCardIcon = document.querySelector('.timeline-card-1__icon');
    const secondCardIcon = document.querySelector('.timeline-card-2__icon');
    if (firstCardIcon && secondCardIcon) {
      secondCardIcon.src = firstCardIcon.src;
      secondCardIcon.alt = firstCardIcon.alt;
      secondCardIcon.title = firstCardIcon.title;

      // 切换类名：移除原有类，添加目标类
      secondCardIcon.classList.remove('timeline-card-2__icon');
      secondCardIcon.classList.add('timeline-card-1__icon');
    }

    hasTriggered = true;
  }

  // 初始化时判断是否已过触发时间：如果当前时间已经在10月31日之后，立即执行变化
  const now = new Date().getTime();
  if (now >= triggerDate) {
    triggerChanges();
  } else {
    // 未到触发时间：计算距离触发时间的毫秒数，设置一次性定时器，到点执行
    const timeToTrigger = triggerDate - now;
    setTimeout(triggerChanges, timeToTrigger);
  }

  // 原有倒计时更新逻辑（只负责更新倒计时数字和结束显示）
  function updateCountdown() {
    const now = new Date().getTime();
    const distance = endDate - now;

    if (distance < 0) {
      // 1. 右侧虚线变实线
      const rightLine = document.querySelector('.timeline-line.timeline-line--dashed.timeline-line--right');
      if (rightLine) {
        rightLine.classList.remove('timeline-line--dashed');
        rightLine.classList.add('timeline-line--solid');
      }

      // 2. 添加静态结束文案（仅添加一次），活动结束的标语
      const containerChildren = container.children;
      for (let i = 0; i < containerChildren.length; i++) {
        const child = containerChildren[i];
        // 排除结束文案元素本身，只淡化其他原有内容
        if (!child.classList.contains('countdown-end-text')) {
          child.style.opacity = '0.05'; // 仅原有内容变透明
        }
      }
      let endElement = container.querySelector('.countdown-end-text');
      if (!endElement) {
        endElement = document.createElement('div');
        endElement.classList.add('countdown-end-text');
        endElement.textContent = endText;
        
        // 设置样式让文案浮在container上方
        endElement.style.position = 'absolute';
        endElement.style.top = '50%';
        endElement.style.left = '50%';
        endElement.style.transform = 'translate(-50%, -50%)';
        
        // 将文案添加到container内部
        container.appendChild(endElement);
      }

      // 3. 彻底清除定时器，停止所有后续更新
      clearInterval(countdownInterval);
      return;
    }

    const days = Math.floor(distance / (1000 * 60 * 60 * 24));
    const hours = Math.floor(
      (distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
    );
    const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((distance % (1000 * 60)) / 1000);

    if (daysEl) daysEl.innerText = days.toString().padStart(2, "0");
    if (hoursEl) hoursEl.innerText = hours.toString().padStart(2, "0");
    if (minutesEl) minutesEl.innerText = minutes.toString().padStart(2, "0");
    if (secondsEl) secondsEl.innerText = seconds.toString().padStart(2, "0");
  }

  // 初始化倒计时并启动定时器
  updateCountdown();
  countdownInterval = setInterval(updateCountdown, 1000);
}

// 美国中部时间 11月2日 23:59:59
const eventEndDate = new Date("2025-11-02T23:59:59-06:00").getTime();

// 启动普通倒计时
startCountdown(eventEndDate, ".countdown-timer-container");

// 启动迷你倒计时
startCountdown(eventEndDate, ".mini-countdown-timer-container");
